import { DEFAULT_LANDING_PAGE_ACCENT_COLOR } from '@consts';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { usePaymentAndOrder } from '../../payments/PaymentAndOrderContext';
import { parseHighlightedText } from './highlighters';
import LandingPageKeywordChip from './LandingPageKeywordChip';
import { isSectionHidden } from './landingPageSections';
import { useLandingPageTranslation } from './useLandingPageTranslation';

export default function GoalLandingPageKeywordsSection() {
  const { state } = usePaymentAndOrder();
  const { t } = useLandingPageTranslation();
  const landingPage = state.goal?.landingPage;
  const keywordsSection = landingPage?.keywords;
  const keywords = keywordsSection?.keywords ?? [];
  const accentColor = landingPage?.accentColor || DEFAULT_LANDING_PAGE_ACCENT_COLOR;
  const sectionTitle =
    keywordsSection?.sectionTitle || t('domains.goals.landingPage.keywords.sectionTitle');

  if (!keywords.length) return <></>;
  if (isSectionHidden(keywordsSection)) return <></>;

  return (
    <div
      className={classNames(
        'w-full max-w-[1200px] mx-auto flex flex-col gap-lg @[640px]:gap-huge items-center justify-center',
        // RESPONSIVE STYLES
        'p-sm @[768px]:p-md @[1280px]:py-xxxl @[1280px]:px-none'
      )}
    >
      <p
        className={classNames(
          'font-bold leading-[1.1] text-center w-full',
          setupForDark('text-white'),
          // RESPONSIVE STYLES
          'text-[32px] @[480px]:text-[48px] @[640px]:text-[60px] break-words'
        )}
      >
        {parseHighlightedText(sectionTitle, 'text-white', undefined, accentColor)}
      </p>
      <div className='flex flex-row flex-wrap gap-sm @[640px]:gap-md items-center justify-center w-full'>
        {keywords.map((keyword, index) => (
          <LandingPageKeywordChip key={index} text={keyword} accentColor={accentColor} />
        ))}
      </div>
    </div>
  );
}
